import PropTypes from 'prop-types'
import React, { Component, type ReactNode, Suspense } from 'react'
import Field from '../../../fields'

interface TeamMemberEditFormPersonalProps {
  fields: Record<string, any>
  formId: string
  style?: Record<string, any>
  teamMemberEnabled?: boolean
  testId?: string
}

class TeamMemberEditFormPersonal extends Component<TeamMemberEditFormPersonalProps> {
  render(): ReactNode {
    const { fields, formId, style, testId } = this.props

    return (
      <div
        style={style}
        data-testid={
          testId ? `${testId}-personal-details-container` : undefined
        }
      >
        <div style={{ paddingBottom: 20 }}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              className="dateofbirth-field"
              keys="dateOfBirth"
              placeholders="DD-MM-YYYY"
              formId={formId}
              label="Date of Birth"
              type="birthdate"
              validationTypes="birthdate"
              values={fields}
              data-testid={testId ? `${testId}-date-of-birth-field` : undefined}
            />
          </Suspense>
        </div>

        <div style={{ paddingBottom: 20 }}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              className="address-field"
              formId={formId}
              keys="address"
              label="Address"
              type="address"
              values={fields}
              data-testid={testId ? `${testId}-address-field` : undefined}
            />
          </Suspense>
        </div>
        <div style={{ paddingBottom: 20 }}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              className="phonenumber-field"
              formId={formId}
              keys="phoneNumber"
              label="Personal Telephone Number"
              options={{
                phone: true,
                phoneRegionCode: 'GB'
              }}
              type="formattedText"
              values={fields}
              data-testid={testId ? `${testId}-phone-number-field` : undefined}
            />
          </Suspense>
        </div>
        <div style={{ paddingBottom: 20 }}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              className="allergies-field"
              keys="hasAllergies"
              label="Allergies"
              formId={formId}
              options={[
                { value: 'Yes', label: 'Yes' },
                { value: 'None known', label: 'None known' }
              ]}
              type="radios"
              values={fields}
              data-testid={testId ? `${testId}-allergies-field` : undefined}
            />
          </Suspense>
        </div>
        <div style={{ paddingBottom: 20 }}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              dependsOn={{
                key: 'hasAllergies',
                value: 'Yes'
              }}
              keys="allergies"
              required
              label="Allergy Details"
              formId={formId}
              type="text"
              values={fields}
              data-testid={
                testId ? `${testId}-allergy-details-field` : undefined
              }
            />
          </Suspense>
        </div>
        <div style={{ paddingBottom: 20 }}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              className="startdate-field"
              keys="startDate"
              placeholders="DD-MM-YYYY"
              formId={formId}
              label="Start Date"
              type="date"
              values={fields}
              data-testid={testId ? `${testId}-start-date-field` : undefined}
            />
          </Suspense>
        </div>
        {this.props.teamMemberEnabled && (
          <div style={{ paddingBottom: 20 }}>
            <Suspense fallback={<div>Loading...</div>}>
              <Field
                className="enddate-field"
                keys="endDate"
                placeholders="DD-MM-YYYY"
                formId={formId}
                label="End Date"
                type="date"
                values={fields}
                data-testid={testId ? `${testId}-end-date-field` : undefined}
              />
            </Suspense>
          </div>
        )}
        <div style={{ paddingBottom: 20 }}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              formId={formId}
              keys={['emergencyContactName.first', 'emergencyContactName.last']}
              label="Emergency Contact"
              placeholders={['First name', 'Last name']}
              type="multiText"
              data-testid={
                testId ? `${testId}-emergency-contact-field` : undefined
              }
              values={fields}
            />
          </Suspense>
        </div>
        <div style={{ paddingBottom: 20 }}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              formId={formId}
              keys="emergencyContactRelation"
              label="Emergency Contact Relation"
              type="text"
              values={fields}
              data-testid={
                testId
                  ? `${testId}-emergency-contact-relation-field`
                  : undefined
              }
            />
          </Suspense>
        </div>
        <div style={{ paddingBottom: 20 }}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              className="emergencynumber-field"
              formId={formId}
              keys="emergencyContactNumber"
              label="Emergency Contact Telephone"
              options={{
                phone: true,
                phoneRegionCode: 'GB'
              }}
              type="formattedText"
              values={fields}
              data-testid={
                testId
                  ? `${testId}-emergency-contact-telephone-field`
                  : undefined
              }
            />
          </Suspense>
        </div>
      </div>
    )
  }
}

export default TeamMemberEditFormPersonal
